import React from 'react';

const VoucherFormSubmitButton = ({ disabled, btnLabel }) =>
  <button type='submit' disabled={disabled} className='voucher-form__btn'>{btnLabel}</button>;

export default VoucherFormSubmitButton;
